/**
 * Keep a stored redirect target only if it stays on this site.
 *
 * For `checkout.metadata.success_url`, which anyone can write via the public checkouts endpoint.
 * The merchant-configured success URL is not run through this; it may point off-site.
 *
 * @param url The stored URL.
 * @returns The URL when it is same-origin http(s), otherwise null.
 */
export const sameOriginUrl = (url?: string | null): string | null => {
  if (!url) return null;
  try {
    const target = new URL(url, window.location.href);
    const isHttp = target.protocol === 'http:' || target.protocol === 'https:';
    return isHttp && target.origin === new URL(window.location.href).origin ? url : null;
  } catch (e) {
    return null;
  }
};
